import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  getValueType,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter4,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import {
  editProductMaster,
  fetchColorMaster,
  fetchIdProductMaster,
  fetchModelMaster,
  selectIdProductMaster,
  selectLoading,
} from "./ProductRelatedSlice";
import { ModalOffice } from "../motorPool/ModalOffice";
import { ModalClient } from "../motorPool/ModalClient";
import { ModalModelSelect } from "./ModalModelSelect";
import { ModalColorSelect } from "./ModalColorSelect";
import { ProductMasterDuplicate } from "./ProductMasterDuplicate";
import { selectPagination } from "../../modules/Auth/_redux/authRedux";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ProductMasterEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdProductMaster);
  const { id } = useParams();
  const dataVolume = useSelector(selectParameter);
  const dataWeigth = useSelector(selectParameter2);
  const dataUom = useSelector(selectParameter3);
  const dataDistance = useSelector(selectParameter4);
  const paginationSet = useSelector(selectPagination);

  // initial

  const [listOffice, setListOffice] = useState([]);
  const [listClient, setListClient] = useState([]);

  // modal setFieldsColor
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [fieldsModel, setFieldsModel] = useState([
    { id: "", value: "", params: "", label: "", add: "N", editor: "text" },
  ]);
  const [fieldsColor, setFieldsColor] = useState([
    { id: "", value: "", params: "", label: "", add: "N", editor: "text" },
  ]);

  const [formValues, setFormValues] = useState({
    product_code: {
      value: "",
      error: false,
      required: "Y",
    },
    product_name: {
      value: "",
      error: false,
      required: "Y",
    },
    product_model: {
      value: "",
      error: false,
      required: "N",
    },
    product_model_name: {
      value: "",
      error: false,
      required: "N",
    },
    product_color: {
      value: "",
      error: false,
      required: "N",
    },
    product_color_name: {
      value: "",
      error: false,
      required: "N",
    },
    product_baseuom: {
      value: "UNT",
      error: false,
      required: "Y",
    },
    product_netweight: {
      value: "",
      error: false,
      required: "N",
    },
    product_grossweight: {
      value: "",
      error: false,
      required: "N",
    },

    product_weighttype: {
      value: "",
      error: false,
      required: "N",
    },
    product_volume: {
      value: "",
      error: false,
      required: "N",
    },
    product_volumetype: {
      value: "",
      error: false,
      required: "N",
    },
    product_length: {
      value: "",
      error: false,
      required: "N",
    },
    product_width: {
      value: "",
      error: false,
      required: "N",
    },
    product_heigth: {
      value: "",
      error: false,
      required: "N",
    },
    product_dimensiontype: {
      value: "",
      error: false,
      required: "N",
    },
    product_inbound_rule: {
      value: "N",
      error: false,
      required: "N",
    },
  });

  const [formDuplicate, setFormDuplicate] = useState({
    product_code: {
      value: "",
      error: false,
      required: "Y",
    },
    product_name: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      callApi(id);
      await dispatch(
        fetchParameter({
          paramgroup_code: "VOLUME_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "WEIGTH_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "BASE_UOM",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "DISTANCE_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchColorMaster({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchModelMaster({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch, id]);

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchIdProductMaster(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        product_code: {
          value: dataId.product_code,
          error: false,
          required: "Y",
        },
        product_name: {
          value: dataId.product_name,
          error: false,
          required: "Y",
        },
        product_model: {
          value: dataId.product_model,
          error: false,
          required: "Y",
        },
        product_model_name: {
          value: dataId.product_model_name,
          error: false,
          required: "N",
        },
        product_color: {
          value: dataId.product_color,
          error: false,
          required: "N",
        },
        product_color_name: {
          value: dataId.product_color_name,
          error: false,
          required: "N",
        },
        product_baseuom: {
          value: dataId.product_baseuom,
          error: false,
          required: "Y",
        },
        product_netweight: {
          value: dataId.product_netweight,
          error: false,
          required: "N",
        },
        product_grossweight: {
          value: dataId.product_grossweight,
          error: false,
          required: "N",
        },

        product_weighttype: {
          value: dataId.product_weighttype,
          error: false,
          required: "N",
        },
        product_volume: {
          value: dataId.product_volume,
          error: false,
          required: "N",
        },
        product_volumetype: {
          value: dataId.product_volumetype,
          error: false,
          required: "N",
        },
        product_length: {
          value: dataId.product_length,
          error: false,
          required: "N",
        },
        product_width: {
          value: dataId.product_width,
          error: false,
          required: "N",
        },
        product_heigth: {
          value: dataId.product_heigth,
          error: false,
          required: "N",
        },
        product_dimensiontype: {
          value: dataId.product_dimensiontype,
          error: false,
          required: "N",
        },
        product_inbound_rule: {
          value: dataId.product_inbound_rule,
          error: false,
          required: "N",
        },
      });
      setListClient(
        dataId.productClients !== null ? dataId.productClients : []
      );
      setListOffice(
        dataId.productOffices !== null ? dataId.productOffices : []
      );
    }
  }, [dataId]);

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (
      formValues.product_code.value.includes("<script>") ||
      formValues.product_code.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (
      formValues.product_name.value.includes("<script>") ||
      formValues.product_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (!validatePost()) {
      return;
    }
    const params = {
      product_id: id,
      product_code: formValues.product_code.value,
      product_name: formValues.product_name.value,
      product_model: formValues.product_model.value,
      product_color: formValues.product_color.value,
      product_baseuom: formValues.product_baseuom.value,
      product_netweight: formValues.product_netweight.value,
      product_grossweight: formValues.product_grossweight.value,
      product_weighttype: formValues.product_weighttype.value,
      product_volume: formValues.product_volume.value,
      product_volumetype: formValues.product_volumetype.value,
      product_length: formValues.product_length.value,
      product_width: formValues.product_width.value,
      product_heigth: formValues.product_heigth.value,
      product_inbound_rule: formValues.product_inbound_rule.value,
      productClients: listClient,
      productOffices: listOffice,
    };
    try {
      const response = await dispatch(editProductMaster(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
        // await dispatch(fetchIdProductMaster(id));
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const countryOptions = [
    {
      value: "value",
      label: "label",
    },
  ];

  const handleChangeCountry = (e, country) => {
    const value = country.value;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
    });
  };

  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.product_code.value
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const options = [{ value: "kg", label: "kg" }];

  const optionsVolume = [{ value: "M", label: "CubicMater" }];

  //   client and office

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) => handleDelete(e, row, rowIndex, formatExtraData)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      formatExtraData: listOffice,
    },
  ];

  const actionFormatterClient = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) =>
              handleDeleteClient(e, row, rowIndex, formatExtraData)
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsClient = [
    {
      text: "Client Code",
      dataField: "client_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Client Name",
      dataField: "client_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterClient,
      align: "center",
      headerAlign: "center",
      formatExtraData: listClient,
    },
  ];

  const handleDelete = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.office_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.office_id !== idColumn);
    setListOffice(items);
  };

  const handleDeleteClient = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.client_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.client_id !== idColumn);
    setListClient(items);
  };

  // modal office

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // modal Client

  const [showClient, setShowClient] = useState(false);

  const handleCloseClient = () => setShowClient(false);
  const handleShowClient = () => setShowClient(true);

  const volumeOptions = dataVolume.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeVolume = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["product_volumetype"]: {
        ...formValues["product_volumetype"],
        value,
      },
    });
  };

  const uomOptions = dataUom.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeUom = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["product_baseuom"]: {
        ...formValues["product_baseuom"],
        value,
      },
    });
  };

  const weigthOptions = dataWeigth.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeWeigth = (e, params) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["product_weighttype"]: {
        ...formValues["product_weighttype"],
        value,
      },
    });
  };

  const indexUom = uomOptions.findIndex(
    (obj) => obj.value === formValues.product_baseuom.value
  );

  const distanceOptions = dataDistance.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });
  const handleChangeDistance = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["product_dimensiontype"]: {
        ...formValues["product_dimensiontype"],
        value,
      },
    });
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              Product Master : {dataId.product_code}
            </CardHeaderTitle>
            <CardHeaderToolbar>
              <Button className="primary" onClick={() => history.goBack()}>
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              <div>
                <p className="font-weight-boldest">Basic Information</p>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="Code"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="product_code"
                      value={formValues.product_code.value}
                      onChange={handleChange}
                      error={formValues.product_code.error}
                      helperText={
                        formValues.product_code.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />

                    <RedditTextField
                      required
                      label="Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="product_name"
                      value={formValues.product_name.value}
                      onChange={handleChange}
                      error={formValues.product_name.error}
                      helperText={
                        formValues.product_name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Model"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          readOnly
                          value={formValues.product_model_name.value}
                          error={formValues.product_model.error}
                          helperText={
                            formValues.product_model.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => setShowModel(true)}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Color"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          readOnly
                          value={formValues.product_color_name.value}
                          error={formValues.product_color.error}
                          helperText={
                            formValues.product_color.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => setShowColor(true)}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <hr />
              {/* Template File */}
              <div>
                <p className="font-weight-boldest">Product Profile</p>
                <div className="mr-3">
                  <p className="font-weight-boldest ml-3">Inbound Rule</p>
                  <Row>
                    <Form.Check
                      inline
                      label="Require Accessories Installation"
                      name="group1"
                      type="checkbox"
                      className="ml-5 mb-4 mt-4 ml-5"
                      onChange={(e) => {
                        if (e.target.checked === true) {
                          setFormValues({
                            ...formValues,
                            ["product_inbound_rule"]: {
                              ...formValues["product_inbound_rule"],
                              value: "Y",
                            },
                          });
                        } else {
                          setFormValues({
                            ...formValues,
                            ["product_inbound_rule"]: {
                              ...formValues["product_inbound_rule"],
                              value: "N",
                            },
                          });
                        }
                      }}
                      checked={
                        formValues.product_inbound_rule.value === "Y"
                          ? true
                          : false
                      }
                    />
                  </Row>
                </div>
              </div>
              <hr />
              <div>
                <p className="font-weight-boldest">Weight & Measurement</p>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Autocomplete
                      disablePortal
                      name="product_baseuom"
                      options={uomOptions}
                      getOptionLabel={(option) => option.label.toString()}
                      disableClearable={true}
                      onChange={handleChangeUom}
                      value={uomOptions[indexUom]}
                      renderInput={(params) => (
                        <RedditTextField
                          required
                          className={classes.margin}
                          {...params}
                          label="Base UOM"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          placeholder="Select UOM"
                          name="product_baseuom"
                          error={formValues.product_baseuom.error}
                          helperText={
                            formValues.product_baseuom.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      )}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col md={4}>
                        <RedditTextField
                          label="Net Weight"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          type="number"
                          name="product_netweight"
                          value={formValues.product_netweight.value}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={4}>
                        <RedditTextField
                          label="Gross Weight"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          type="number"
                          name="product_grossweight"
                          value={formValues.product_grossweight.value}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={4}>
                        <Select
                          options={weigthOptions}
                          value={getValueType(
                            formValues.product_weighttype.value,
                            weigthOptions
                          )}
                          placeholder="Type"
                          onChange={handleChangeWeigth}
                          className="mt-4 "
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div>
                <p className="font-weight-boldest">Dimension</p>
                <Row>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <RedditTextField
                      label="Length"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="product_length"
                      value={formValues.product_length.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <p className="font-weight-boldest ml-4 mt-7">X</p>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <RedditTextField
                      label="Width"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="product_width"
                      value={formValues.product_width.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <p className="font-weight-boldest ml-4 mt-7">X</p>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <RedditTextField
                      label="Heigth"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="product_heigth"
                      value={formValues.product_heigth.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col>
                    <Select
                      options={distanceOptions}
                      value={getValueType(
                        formValues.product_dimensiontype.value,
                        distanceOptions
                      )}
                      onChange={handleChangeDistance}
                      className="mt-4 ml-3"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <RedditTextField
                      label="Volume"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="product_volume"
                      value={formValues.product_volume.value}
                      onChange={handleChange}
                    />
                  </Col>

                  <Col md={3}>
                    <Select
                      // isClearable={true}
                      options={volumeOptions}
                      value={getValueType(
                        formValues.product_volumetype.value,
                        volumeOptions
                      )}
                      // placeholder="Type"
                      onChange={handleChangeVolume}
                      className="mt-4 ml-3"
                    />
                  </Col>
                </Row>
              </div>
            </ThemeProvider>
            <hr />

            {/* Office */}
            <div>
              <p className="font-weight-boldest">Associated Offices</p>

              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                bootstrap4
                
                keyField="No"
                data={listOffice}
                columns={columns}
                // sort={{ dataField: sortField, order: sortOrder }}
                hover
                striped
                headerClasses="header-class"
              />

              <Row className="mt-6 justify-content-end">
                <Button variant="outline-primary" onClick={handleShow}>
                  Add Office
                </Button>
              </Row>
            </div>
            <hr />
            {/* Client */}
            <div>
              <p className="font-weight-boldest">Associated Clients</p>

              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                bootstrap4
                
                keyField="client_id"
                data={listClient}
                columns={columnsClient}
                hover
                striped
                headerClasses="header-class"
              />

              <Row className="mt-6 justify-content-end">
                <Button variant="outline-primary" onClick={handleShowClient}>
                  Add Client
                </Button>
              </Row>
            </div>

            {/* handleSave */}
            <Row className="mt-6 justify-content-end">
              <Button
                className="btn btn-primary my-btn-primary-dark text-bold mr-5"
                onClick={(e) => setShowDuplicate(true)}
              >
                Duplicate
              </Button>
              <Button variant="primary" onClick={handleSave}>
                Save
              </Button>
            </Row>
          </CardBody>
        </Card>

        {/* Modal Create */}

        <ModalOffice
          isOpen={show}
          handleClose={handleClose}
          handleShow={handleShow}
          setListOffice={setListOffice}
          listOffice={listOffice}
        />

        <ModalClient
          isOpen={showClient}
          handleClose={handleCloseClient}
          handleShow={handleShowClient}
          setListClient={setListClient}
          listClient={listClient}
        />

        <ModalModelSelect
          isOpen={showModel}
          setShow={setShowModel}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFieldsModel}
          fields={fieldsModel}
        />
        <ModalColorSelect
          isOpen={showColor}
          setShow={setShowColor}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFieldsColor}
          fields={fieldsColor}
        />
        <ProductMasterDuplicate
          id={id}
          isOpen={showDuplicate}
          setShow={setShowDuplicate}
          setFormValues={setFormDuplicate}
          formValues={formDuplicate}
        />
      </>
    )
  );
};
